export enum EarningsPageEnum {
  EARNINGS_INFO = 1,
  EARNINGS_HISTORY
}

export enum FilterToggleEnum {
  FILTER = 1,
  SORT,
  DATE
}

export enum DateToggleEnum {
  START = 1,
  END
}

export enum EarningsHistoryFilterEnum {
  TEAM_BONUS = 1,
  DIRECT_BONUS,
  MATCHING_BONUS,
  CASHBACK_BONUS,
  GLOBAL_POOL_BONUS,
  TOP_PERFORMER_BONUS,
  HODL_POOL_BONUS,
  PACKAGE_RANK,
  OTHER_BONUSES,
  CUSTOMER_BONUS,
  TRADING_BONUS,
  PENDING,
  PAID,
  LOYALITY,
  MYLIFE
}

export enum EarningsSortByEnum {
  DATE_UP = 'dateUp',
  DATE_DOWN = 'dateDown',
  PRICE_UP = 'priceUp',
  PRICE_DOWN = 'priceDown'
}

interface PartnerEarnings {
  directBonusEarnings: number;
  todayDirectBonusEarnings: number;
  teamBonusEarnings: number;
  todayTeamBonusEarnings: number;
  matchingBonusEarnings: number;
  todayMatchingBonusEarnings: number;
  cashbackBonusEarnings: number;
  todayCashbackBonusEarnings: number;
  packageRankRewardsEarnings: number;
  todayPackageRankRewardsEarnings: number;
  legacyBonusEarnings: number;
  tradingBonusEarnings: number;
  todayTradingBonusEarnings: number;
}

interface TotalEarnings {
  totalEarnings: number;
  todayTotalEarnings: number;
  pendingBalance: number;
  availableBalance: number;
  todayAvailableBalance: number;
  shoppingPoints: number;
  todayShoppingPoints: number;
  ulxPoints: number;
  todayUlxPoints: number;
  loyaltyPoints: number;
  todayLoyaltyPoints: number;
  nextLpExpiryDate: string;
  myLifePoints: number;
  todayMyLifePoints: number;
}

export interface EarningInfoModel {
  partnerEarnings: PartnerEarnings;
  totalEarnings: TotalEarnings;
}

export interface GetEarningsInfoForUserResponse {
  info: EarningInfoModel;
  shoudEnableWithdraw: boolean;
}

export interface GetEarningsHistoryResponse {
  earnings: EarningHistoryModel[];
}

export interface GetEarningByTypeAndIdResponse {
  earning: EarningModel;
}

interface Package {
  packageId: number;
  name: string;
  price: number;
  teamBonusPercent: number;
  order: number;
  stakeRatio: number;
  weekCapRuleLimit: number;
  volumePoints: number;
  type: number;
}

interface PackageRank {
  packageRankId: number;
  name: string;
}

interface UserPackage {
  id: number;
  price: number;
  shoppingPoints: number;
  donationPoints: number;
  teamBonusPercent: number;
  status: number;
  dateCreated: string;
  datePaid: string;
  networkType: number;
  paymentAddress: string;
  package: Package;
  packageRank: PackageRank;
  nextPackageRank: PackageRank;
}

interface User {
  id: number;
  profileImageUrl: string;
  name: string;
  surname: string;
  username: string;
  userPackage: UserPackage;
}

export interface EarningModel {
  type: number;
  id: number;
  bonusDateCreated: string;
  status: number;
  amount: number;
  datePaid: string;
  user: User;
  packageRankName: string;
  orderAmount: number;
  orderId: number;
  orderDateCreated: string;
  name: string;
}

export interface EarningHistoryModel {
  type: number;
  id: number;
  packageRankName: string;
  dateCreated: string;
  status: number;
  amount: number;
  username: string;
}
export interface WithdrawAvailability {
  isAvailable: boolean;
  limitDate: string;
}
